import { render, staticRenderFns } from "./SecurityWarning.vue?vue&type=template&id=986b9a52&scoped=true"
import script from "./SecurityWarning.vue?vue&type=script&lang=ts"
export * from "./SecurityWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986b9a52",
  null
  
)

export default component.exports